<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    {
      label: 'STATIC_CONTENT_TEMPLATES',
      url: '/admin/static-content-templates'
    },
    { label: 'UPDATE_STATIC_CONTENT_TEMPLATE' }
  ]"
></breadcrumbs>

<page-header
  title="{{ 'UPDATE_STATIC_CONTENT_TEMPLATE' | translate }}"
></page-header>
<card>
  <radio
    [options]="languages"
    name="language"
    [controlled]="true"
    [value]="selectedLanguage"
    (onChange)="languageChange($event)"
  ></radio>

  <form autocomplete="off" class="form pt-3" (submit)="onSubmit($event)">
    <div class="field is-narrow pb-2">
      <div class="control">
        <span
          [translationEditableDirective]="getField(['key', 'translationKey'])"
          >{{ getField(['key', 'translationKey']) | translate }}</span
        >
      </div>
      <p class="help is-danger" *ngIf="hasError('title')">
        {{ getError('title') }}
      </p>
    </div>

    <div class="field is-narrow">
      <div class="control">
        <text-editor
          [value]="getField(['content'])"
          (onChange)="handleFieldChange($event, 'content')"
        ></text-editor>
      </div>
      <p class="help is-danger" *ngIf="hasError('content')">
        {{ getError('content') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped mb-3 px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/static-content-templates']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
